<template lang="pug">
v-dialog(width="300", v-model="dialog")
  template(v-slot:activator="{ on }")
    v-btn(v-on="on") SMS
  v-card
    v-card-title Send SMS
    v-card-text
      v-form(@submit.prevent="submit")
        PhoneField(v-model="number")
        v-text-field(v-model="message")
        v-btn(block, type="submit", color="secondary", :loading="loading") Send Message
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      number: "",
      message: "",
      loading: false,
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const params = { phone: this.number, message: this.message };
        const { data } = await this.axios.post("/misc/sms", params);
        this.$toast.success(data);
        this.dialog = false;
      } catch (err) {
        this.$toast.error(err.response?.data || err.message);
      }
      this.loading = false;
    },
  },
};
</script>
